const HttpStatus = {
    OK: 200,
    CREATED: 201,
    UNAUTHORIZED: 401,
    BAD_REQUEST: 400,
    NOT_FOUND: 404,
    INTERNAL_SERVER_ERROR: 500
};

export default HttpStatus;